var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "emd-container__footer" }, [
    _c(
      "span",
      {
        staticClass: "emd-text _color_default _size_small",
        attrs: { "data-testid": "pagination-results" },
      },
      [
        _vm.pagination.total_items
          ? _c("span", [
              _vm._v(
                _vm._s(_vm.$t("pagination.showing")) +
                  " " +
                  _vm._s(this.totalShowing) +
                  " " +
                  _vm._s(_vm.$t("pagination.of")) +
                  " " +
                  _vm._s(_vm.pagination.total_items) +
                  " " +
                  _vm._s(_vm.$t("pagination.results"))
              ),
            ])
          : _vm._e(),
      ]
    ),
    _c("div", [
      _c(
        "button",
        {
          staticClass: "emd-btn _color_primary _type_text",
          attrs: {
            "data-testid": "button-previous",
            disabled: _vm.disablePreviousButton(),
          },
          on: {
            click: function ($event) {
              return _vm.changePage("previous")
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("pagination.previous")) + " ")]
      ),
      _c(
        "button",
        {
          staticClass: "emd-btn _color_primary _type_text",
          attrs: {
            "data-testid": "button-next",
            disabled: _vm.disableNextButton(),
          },
          on: {
            click: function ($event) {
              return _vm.changePage("next")
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("pagination.next")) + " ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }